/**
 * The suggestions card's side effects, wired to the real API and caches:
 * the editor open in the panel, `page-edits`, a version's document,
 * `PUT document`, and the refresh after an applied suggestion.
 */
import { useMemo } from 'react';
import { getArtifactVersion, saveArtifactDocument, savePageEdits } from '@/lib/artifact-edits-api';
import { useInvalidateArtifact } from '@/hooks/useArtifactVersions';
import { readActiveEditor } from '../editor/active-editor';
import type { SuggestionsDeps } from './suggestions-controller';

export function useSuggestionsDeps(): SuggestionsDeps {
  const invalidate = useInvalidateArtifact();
  return useMemo<SuggestionsDeps>(
    () => ({
      activeEditor: (artifactId) => readActiveEditor(artifactId),
      savePageEdits: (artifactId, body) => savePageEdits(artifactId, body),
      loadDocument: async (artifactId, versionId) => (await getArtifactVersion(artifactId, versionId)).document,
      saveDocument: (artifactId, body) => saveArtifactDocument(artifactId, body),
      onChanged: invalidate,
    }),
    [invalidate],
  );
}
